import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SearchFilterBar = ({ onSearch, onFilterChange }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('all');
  const [selectedLanguage, setSelectedLanguage] = useState('all');
  const [selectedType, setSelectedType] = useState('all');

  const topicOptions = [
    { value: 'all', label: 'Все темы' },
    { value: 'philosophy', label: 'Философия' },
    { value: 'mindfulness', label: 'Осознанность' },
    { value: 'culture', label: 'Культура' },
    { value: 'travel', label: 'Путешествия' },
    { value: 'music', label: 'Музыка' },
    { value: 'storytelling', label: 'Истории' },
    { value: 'meditation', label: 'Медитация' }
  ];

  const languageOptions = [
    { value: 'all', label: 'Все языки' },
    { value: 'ru', label: 'Русский' },
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Español' },
    { value: 'fr', label: 'Français' }
  ];

  const typeOptions = [
    { value: 'all', label: 'Все типы' },
    { value: 'live', label: 'Прямой эфир' },
    { value: 'recorded', label: 'Записи' },
    { value: 'podcast', label: 'Подкасты' },
    { value: 'music', label: 'Музыка' }
  ];

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchQuery(value);
    onSearch(value);
  };

  const handleTopicChange = (value) => {
    setSelectedTopic(value);
    onFilterChange({ topic: value, language: selectedLanguage, type: selectedType });
  };

  const handleLanguageChange = (value) => {
    setSelectedLanguage(value);
    onFilterChange({ topic: selectedTopic, language: value, type: selectedType });
  };

  const handleTypeChange = (value) => {
    setSelectedType(value);
    onFilterChange({ topic: selectedTopic, language: selectedLanguage, type: value });
  };

  const handleClearFilters = () => {
    setSearchQuery('');
    setSelectedTopic('all');
    setSelectedLanguage('all');
    setSelectedType('all');
    onSearch('');
    onFilterChange({ topic: 'all', language: 'all', type: 'all' });
  };

  return (
    <div className="search-filter-bar bg-card rounded-lg border border-border p-4 mb-6">
      <div className="search-section mb-4">
        <Input
          type="search"
          placeholder="Поиск эфиров, каналов, тем..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full"
        />
      </div>

      <div className="filter-section">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <Select
            label="Тема"
            options={topicOptions}
            value={selectedTopic}
            onChange={handleTopicChange}
          />

          <Select
            label="Язык"
            options={languageOptions}
            value={selectedLanguage}
            onChange={handleLanguageChange}
          />

          <Select
            label="Тип"
            options={typeOptions}
            value={selectedType}
            onChange={handleTypeChange}
          />

          <div className="flex items-end">
            <button
              onClick={handleClearFilters}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 border border-border rounded-lg hover:bg-muted transition-colors duration-200"
            >
              <Icon name="X" size={18} color="var(--color-foreground)" />
              <span className="text-sm font-heading font-medium text-foreground">
                Сбросить фильтры
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFilterBar;